
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.23 15.5C5.429 15.5 1.863 14.279 0 12.903V22h24v-8.949c-3.218 2.221-9.422 2.449-11.77 2.449zM14 18.032C14 19.119 13.104 20 12 20s-2-.881-2-1.968V17h4v1.032zM0 9.491V7h24v2.605c0 5.289-24 5.133-24-.114zM9 2a2 2 0 00-2 2v2h2V4.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V6h2V4a2 2 0 00-2-2H9z"}})])
          )
        }
      }
    